import { Flex, Box, Text } from '@chakra-ui/react'

export const NotFound = ({ code, text }: { code?: string; text?: string }) => {
  return (
    <Flex minHeight={'70vh'} justifyContent={'center'} alignItems={'center'}>
      <Box userSelect={'none'} textAlign={'center'} fontWeight={700}>
        <Text color={'ninja.100'} mb={1} fontSize={92} lineHeight={1}>
          {code ? code : 404}
        </Text>
        <Text color={'ninja.200'}>{text ? text : 'This page could not be found.'}</Text>
      </Box>
    </Flex>
  )
}
